import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgIconComponent, provideIcons } from '@ng-icons/core';
import { heroArrowRightOnRectangle, heroChevronRight } from '@ng-icons/heroicons/outline';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { MenuModule } from 'primeng/menu';
import { ToolbarModule } from 'primeng/toolbar';
import { ButtonComponent } from '../../../shared/components/button/button.component';
import { UserAvatarComponent } from '../../../shared/components/user-avatar/user-avatar.component';
import { AuthService } from '../../auth/services/auth.service';
import { BreadcrumbService } from '../../services/breadcrumb.service';
import { ProfileService } from '../../services/profile.service';

@Component({
  selector: 'app-header',
  imports: [
    CommonModule,
    RouterModule,
    ButtonModule,
    ToolbarModule,
    AvatarModule,
    MenuModule,
    NgIconComponent,
    ButtonComponent,
    UserAvatarComponent,
  ],
  templateUrl: './header.html',
  styleUrl: './header.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    provideIcons({
      heroArrowRightOnRectangle,
      heroChevronRight,
    }),
  ],
})
export class Header {
  private authService = inject(AuthService);
  private profileService = inject(ProfileService);
  private breadcrumbService = inject(BreadcrumbService);

  // breadcrumbs from service
  readonly breadcrumbs = this.breadcrumbService.breadcrumbs;

  // auth state
  readonly isAuthenticated = this.authService.isAuthenticated;

  // user display name
  readonly userName = computed(() => {
    const user = this.authService.currentUser();
    return user?.name ?? user?.username;
  });

  // avatar image url from profile service
  readonly avatarUrl = this.profileService.avatarUrl;

  logout(): void {
    this.authService.logout();
  }
}
